"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Label;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
function Label(props) {
  const classes = [];
  sizes.forEach(size => {
    if (props[size]) {
      classes.push('col-' + size + '-' + props[size]);
    }
  });
  classes.push('form-control-label');
  return /*#__PURE__*/_react.default.createElement("label", {
    className: classes.join(' ')
  }, props.children);
}